module.exports = __webpack_public_path__ + "static/logosTwo.82754405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logosTwo.png
// module id = ./src/assets/logosTwo.png
// module chunks = 226020273838829